import initLazyLoading from "./helper/lazyload-images";

(function () {
  /**
   * Add lazy loading support
   */
  initLazyLoading();

  /**
   * IE and EDGE fallback for images with object-fit="cover"
   * Source: https://stackoverflow.com/a/37792830
   */
  if ("objectFit" in document.documentElement.style === false) {
    document.addEventListener("DOMContentLoaded", function () {
      const imageObjects = document.querySelectorAll("img[data-object-fit]");

      for (let io = 0; io < imageObjects.length; io++) {
        let image = imageObjects[io];
        let imageSrc = image.hasAttribute("data-src")
          ? image.getAttribute("data-src")
          : image.src; // fallback for cached files in current behind you theme

        // imageSrc += "?ver=" + d.getTime();

        (image.runtimeStyle || image.style).background = 'url("'
          .concat(imageSrc, '") no-repeat 50%/')
          .concat(
            image.currentStyle
              ? image.currentStyle["object-fit"]
              : image.getAttribute("data-object-fit")
          );

        image.className = "";
        image.src =
          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='"
            .concat(image.width, "' height='")
            .concat(image.height, "'%3E%3C/svg%3E");
      }
    });
  }
})();
